module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Promo12.c1f0b3be.jpg";